module.exports = __webpack_public_path__ + "static/media/dashboard-update.006ec3a7.png";